import React from 'react';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { ORDER_STATUSES } from './crmConstants';

export const DEFAULT_INCOME_ORDER_FILTERS = { status: 'Publicada', from: '', to: '', invoiced: 'no' };

export const orderPublicationDate = (o) => String(o.final_date || o.created_at || '').slice(0, 10);

export const isOrderInvoiced = (o, ownNumber = '') => {
  const n = String(o.invoice_income_number || '').trim();
  return !!n && n !== String(ownNumber || '').trim();
};

export const matchesIncomeOrderFilters = (o, f, ownNumber = '') => {
  if (f.status !== 'all' && o.status !== f.status) return false;
  const d = orderPublicationDate(o);
  if (f.from && (!d || d < f.from)) return false;
  if (f.to && (!d || d > f.to)) return false;
  if (f.invoiced === 'no' && isOrderInvoiced(o, ownNumber)) return false;
  if (f.invoiced === 'yes' && !isOrderInvoiced(o, ownNumber)) return false;
  return true;
};

export const IncomeOrderFilters = ({ value, onChange }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-2" data-testid="income-order-filters">
    <Select value={value.status} onValueChange={(v) => onChange({ ...value, status: v })}>
      <SelectTrigger className="h-8 text-xs" data-testid="income-order-filter-status"><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Todos los estados</SelectItem>
        {ORDER_STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
      </SelectContent>
    </Select>
    <Input type="date" className="h-8 text-xs" title="Publicado desde" value={value.from} onChange={(e) => onChange({ ...value, from: e.target.value })} data-testid="income-order-filter-from" />
    <Input type="date" className="h-8 text-xs" title="Publicado hasta" value={value.to} onChange={(e) => onChange({ ...value, to: e.target.value })} data-testid="income-order-filter-to" />
    <Select value={value.invoiced} onValueChange={(v) => onChange({ ...value, invoiced: v })}>
      <SelectTrigger className="h-8 text-xs" data-testid="income-order-filter-invoiced"><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="no">No facturados</SelectItem>
        <SelectItem value="yes">Solo facturados</SelectItem>
        <SelectItem value="all">Todos</SelectItem>
      </SelectContent>
    </Select>
  </div>
);
